import { Grid } from '@mui/material';

import { gridSizeMdLg6 } from '@/shared';
import { CustomTextFieldNoForm } from '@/shared/components/ui';
import { EncuestaPreagendaType } from '@/shared/interfaces';

export type EncuestaFieldsComponentProps = {
  encuesta: EncuestaPreagendaType;
};

const EncuestaFieldsComponent: React.FC<EncuestaFieldsComponentProps> = ({
  encuesta,
}) => {
  return (
    <>
      <Grid item xs={12} container spacing={3}>
        <CustomTextFieldNoForm
          label="Número de Pisos"
          value={encuesta?.numero_pisos}
          disabled
          size={gridSizeMdLg6}
        />
        <CustomTextFieldNoForm
          label="Tipo de Vivienda"
          value={encuesta?.tipo_vivienda}
          disabled
          size={gridSizeMdLg6}
        />
        <CustomTextFieldNoForm
          label="Cómo se enteró"
          value={encuesta?.como_se_entero}
          disabled
          size={gridSizeMdLg6}
        />
        <CustomTextFieldNoForm
          label="Número de Dispositivos"
          value={encuesta?.numero_dispositivos}
          disabled
          size={gridSizeMdLg6}
        />
        <CustomTextFieldNoForm
          label="Herramienta Utilizada"
          value={encuesta?.herramienta_utilizada}
          disabled
          size={gridSizeMdLg6}
        />
      </Grid>
    </>
  );
};

export default EncuestaFieldsComponent;
